var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-category-setting"},[_c('md-card',[_c('md-card-header',[_vm._v("Article Category Setting")]),_c('md-card-content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }